module.exports = __webpack_public_path__ + "static/media/sound-related-podcast.264aa419.png";